import graphql from "babel-plugin-relay/macro";

const InviteQuery = graphql`
query InviteQuery{
  whoami{
    id
    username
    referralCode
    referralLink
  }
}
`

export default InviteQuery;